import React, { FunctionComponent, useContext, useMemo } from 'react';
import { navigate } from 'gatsby';
import classNames from 'classnames/bind';

import { AppStore } from '../../../../store/app.context';

import { IAuthorData } from '../../../../utils/authorsDataResolver';
import {
  authorUrl,
  blogArticleUrl,
  webinarArticleUrl
} from '../../../../utils/utils';

import { InternalLink } from '../../../internal-link/internal-link';

import faceLess from '../../../../assets/images/faceless.webp';

import styles from './blog-author-box.module.scss';

const cx = classNames.bind(styles);

export interface IBlogAuthorBoxProps {
  data: IAuthorData;
  hideLinks: boolean;
}

export const BlogAuthorBox: FunctionComponent<IBlogAuthorBoxProps> = ({
  data: { articles, authorData },
  hideLinks
}) => {
  const {
    state: {
      showPageState: { currentLanguage }
    }
  } = useContext(AppStore);

  const classes = cx({ hide: hideLinks });

  const navigateToArticle = (
    event: React.MouseEvent<HTMLElement>,
    slug: string,
    category: string
  ): void => {
    event.preventDefault();
    const articleUrl =
      category === ''
        ? webinarArticleUrl(slug)
        : blogArticleUrl(slug, category);

    currentLanguage !== 'en'
      ? navigate(`/${currentLanguage}${articleUrl}`)
      : navigate(`${articleUrl}`);
  };

  const slicedArticles = useMemo(
    () => (hideLinks ? articles : articles.slice(0, 3)),
    [articles, hideLinks]
  );

  return (
    <InternalLink className={styles.wrapper} url={authorUrl(authorData.slug)}>
      <div className={styles.image}>
        <img
          src={authorData.photoUrl ? authorData.photoUrl : faceLess}
          alt=""
        />
      </div>
      <div className={styles.content}>
        <div className={styles.authorInfo}>
          <h4 className={styles.authorName}>
            <span>{authorData.firstName}</span>{' '}
            <span>{authorData.lastName}</span>
          </h4>
          <div className={styles.authorPosition}>{authorData.position}</div>
        </div>
        <ul className={styles.articlesList}>
          {slicedArticles.map((article, i) => (
            <li
              className={`${styles.listItem} ${i >= 2 ? classes : ''}`}
              key={i}
              onClick={(event): void =>
                navigateToArticle(event, article.slug, article.category)
              }
            >
              <span className={styles.articleLink}>{article.title}</span>
            </li>
          ))}
        </ul>
      </div>
    </InternalLink>
  );
};
